import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Subject } from 'rxjs';
import { AboutYouModel, PersonnelContactModel } from '../model';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: AboutYouModel };

const initialState: State = { state: 'idle' };

@Injectable({ providedIn: 'root' })
export class AboutYouStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));

  readonly setDataValid = this.updater<AboutYouModel>((_, data) => ({ state: 'valid', data }));

  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));

  readonly submit$ = new Subject<void>();

  readonly setPersonnelContactToAboutYou = this.updater<PersonnelContactModel>((state, personnelContact) => {
    if (state.state === 'valid') {
      // console.log('set personnel contact to about you', { personnelContact, currentState: state });

      state.data.contactAreaCode = personnelContact.contactAreaCode;
      state.data.contactNumber = personnelContact.contactNumber;
      state.data.email = personnelContact.email;

      return { ...state }; // return new state to trigger change detection
    }

    return state;
  });

  constructor() {
    super(initialState);
  }
}
